// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"1d6e49bd","488":"6d7e9a16","672":"c5cc4dc5"}[chunkId] + ".chunk.js";
};